<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <el-input class="search_input search_inputBox" v-model="params.keyword" placeholder="公司名称/联系电话" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.salesman_id" multiple collapse-tags placeholder="所属人" @visible-change="getSelectList('disabledUser')">
                    <el-option v-for="list in selectMap.disabledUser" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_select search_inputBox" v-model="params.main_business" placeholder="主营项目" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.customer_attribute_id" multiple collapse-tags placeholder="客户属性" @visible-change="getSelectList('customerAttribute')">
                    <el-option v-for="list in selectMap.customerAttribute" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.customer_source_id" multiple collapse-tags placeholder="客户来源" @visible-change="getSelectList('customerSource')">
                    <el-option v-for="list in selectMap.customerSource" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.province_id" collapse-tags placeholder="省份" @change="changePro($event,1)">
                    <el-option v-for="list in proList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.city_id" collapse-tags placeholder="城市">
                    <el-option v-for="list in cityListS" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.lock_status" multiple collapse-tags placeholder="锁定状态">
                    <el-option :value="1" label="已锁"></el-option>
                    <el-option :value="0" label="未锁"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.remark" placeholder="备注" size="mini"></el-input>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <!-- <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button> -->
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <!-- <span class="excel_btn"> <i class="settings-icon"></i> </span> -->
                    <span class="excel_btn" style="margin-left:10px;" v-if="module.indexOf(',customer-import,')!=-1" @click="importDialogVisible=!importDialogVisible"><i class="excel-icon"></i>excel导入</span>
                    <span class="excel_btn" v-if="module.indexOf(',customer-export,')!=-1" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',customer-add,')!=-1" @click="openAddCustmoer()">新增客户</el-button>
                <el-button class="funcPublicBtn" @click="distributionDia" v-if="module.indexOf(',customer-allot,')!=-1">分配</el-button>
                <el-button class="funcPublicBtn" @click="batchDel" v-if="module.indexOf(',customer-del,')!=-1">批量删除</el-button>
                <el-button class="funcPublicBtn" @click="uploadFile">上传文件</el-button>
                <el-button class="funcPublicBtn" @click="batchLock" v-if="module.indexOf(',customer-lock,')!=-1">批量上锁</el-button>
                <el-button class="funcPublicBtn" @click="batchUnlocking" v-if="module.indexOf(',customer-lock,')!=-1">批量解锁</el-button>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="customer.list"  :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="selectChange" @rowClick="rowClick" @getTableEdit="edit" @getTableDelete="del" @statusClick="statusClick"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <el-dialog v-dialog-drag :title="updataType==2?'新增客户':'修改客户'" class="eldialog eldialogA" :visible.sync="dialogVisible" :model="false" custom-class="full_dialog">
            <div class="">
                <el-form :model="form_params" :rules="rules" ref="edit_form" style="overflow-y: auto;max-height: 600px;">
                    <div class="dialog_path_title eldialogFormTag">基本信息</div>
                    <div class="eldialogFormBox clearfix">
                        <el-form-item label="公司名称：" prop="name">
                            <el-input class="edit_input" v-model="form_params.name" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="公司地址：" prop="address">
                            <el-input class="edit_input" v-model="form_params.address" placeholder=""></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="联系人：" prop="linkman">
                            <el-input class="edit_input" v-model="form_params.linkman" placeholder=""></el-input>
                        </el-form-item> -->
                        <el-form-item label="所属人：" prop="salesman_id">
                            <el-select class="edit_input" v-model="form_params.salesman_id" @visible-change="getSelectList('user')">
                                <el-option v-for="sale in selectMap.user" :key="sale.id" :value="sale.id" :label="sale.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="电话/传真：" prop="fax">
                            <el-input class="edit_input" v-model="form_params.fax" placeholder=""></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="联系电话：" prop="phone">
                            <el-input class="edit_input" v-model="form_params.phone" placeholder=""></el-input>
                        </el-form-item> -->
                        <!-- <el-form-item label="微信：" prop="wechat">
                            <el-input class="edit_input" v-model="form_params.wechat" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="电子邮箱：" prop="email">
                            <el-input class="edit_input" v-model="form_params.email" placeholder=""></el-input>
                        </el-form-item> -->
                        <el-form-item label="工厂规模：" prop="factory_size">
                            <el-input class="edit_input" v-model="form_params.factory_size" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="厂房信息：" prop="factory_size">
                            <el-input class="edit_input" v-model="form_params.factory_info" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="采购木种：" prop="wood_category">
                            <el-input class="edit_input" v-model="form_params.wood_category" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="其他信息：" prop="other_info">
                            <el-input class="edit_input" v-model="form_params.other_info" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogFormBox clearfix">
                        <el-form-item label="所在省份：" prop="province_id">
                            <el-select class="edit_input" v-model="form_params.province_id" @change="changePro($event,2)">
                                <el-option v-for="pro in proList" :key="pro.id" :value="pro.id" :label="pro.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所在城市：" prop="city_id">
                            <el-select class="edit_input" v-model="form_params.city_id">
                                <el-option v-for="city in cityList" :key="city.id" :value="city.id" :label="city.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户属性：" prop="customer_attribute_id">
                            <el-select class="edit_input" v-model="form_params.customer_attribute_id" @visible-change="getSelectList('customerAttribute')">
                                <el-option v-for="attribute in selectMap.customerAttribute" :key="attribute.id" :value="attribute.id" :label="attribute.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户来源：" prop="customer_source_id">
                            <el-select class="edit_input" v-model="form_params.customer_source_id" @visible-change="getSelectList('customerSource')">
                                <el-option v-for="source in selectMap.customerSource" :key="source.id" :value="source.id" :label="source.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="主营项目：" prop="main_business">
                            <el-input class="edit_input" v-model="form_params.main_business" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="信用指数：" prop="star">
                            <el-select class="edit_input" v-model="form_params.star">
                                <el-option :value="1" :label="'一星'"></el-option>
                                <el-option :value="2" :label="'二星'"></el-option>
                                <el-option :value="3" :label="'三星'"></el-option>
                                <el-option :value="4" :label="'四星'"></el-option>
                                <el-option :value="5" :label="'五星'"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户文件：" v-if="form_params.files">
                            <span style="float: left;font-size: 12px;color: #b21111;" @click="openFile">资料查看</span><img  @click="openFile" class="file" src="/icon/file.png">
                        </el-form-item>
                        <el-form-item v-else>
                        </el-form-item>
                        <div class="mark">
                            <el-form-item label="备注：" prop="remark">
                                <!-- <el-input class="edit_input" v-model="form_params.remark" placeholder=""></el-input> -->
                                <div class="content_box">
                                    <span class="content">{{form_params.remark}}</span>
                                    <span class="edit cursorPointer"  @click="markEdit"></span>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="dialog_path_title eldialogFormTag">联系方式</div>
                    <template v-for="(item,index) in form_params.contacts">                
                        <div :class="['link_item', index == 0 ? '':'add_item']" :key="index">
                            <div class="eldialogFormBox clearfix">
                                <el-form-item label="联系人：" :prop="`contacts[${index}].contact`" :rules="{ required: true, message: '必填项', trigger: 'change' }">
                                    <el-input v-model="item.contact" class="edit_input" ></el-input>
                                </el-form-item>
                                <el-form-item label="联系电话：" :prop="`contacts[${index}].phone`" :rules="{ required: true, message: '必填项', trigger: 'change' }">
                                    <el-input v-model="item.phone" class="edit_input" ></el-input>
                                </el-form-item>            
                            </div>
                            <div class="eldialogFormBox clearfix">
                                <el-form-item label="微信：">
                                    <el-input v-model="item.wechat" class="edit_input" ></el-input>
                                </el-form-item>
                                <el-form-item label="电子邮箱：">
                                    <el-input v-model="item.email" class="edit_input" ></el-input>
                                </el-form-item>
                            </div>
                            <div :class="['item_icon','cursorPointer',index == 0 ? 'add_icon':'del_icon']"  @click="addOrDelete(index)"></div>
                        </div>
                    </template>    
                    <div class="dialog_path_title eldialogFormTag">开票资料</div>
                    <div class="eldialogFormBox eldialogFormTag clearfix">
                        <el-form-item label="名称：" prop="invoice_name" style="margin-top: 21px;">
                            <el-input class="edit_input" v-model="form_params.invoice_name" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="开户行：" prop="invoice_bank_name" style="margin-top: 21px;">
                            <el-input class="edit_input" v-model="form_params.invoice_bank_name" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogFormBox eldialogFormTag clearfix">
                        <el-form-item label="税号：" prop="invoice_no">
                            <el-input class="edit_input" v-model="form_params.invoice_no" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="账号：" prop="invoice_bank_no">
                            <el-input class="edit_input" v-model="form_params.invoice_bank_no" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogFormBox eldialogFormTag clearfix">
                        <el-form-item label="地址：" prop="invoice_addr">
                            <el-input class="edit_input" v-model="form_params.invoice_addr" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="invoice_phone">
                            <el-input class="edit_input" v-model="form_params.invoice_phone" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="addCustomer">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisible=!dialogVisible">关闭</el-button>
            </div>
        </el-dialog>
        <el-dialog v-dialog-drag title="客户信息" class="eldialog eldialogA" :visible.sync="customerDetail" :model="false" custom-class="full_dialog">
            <div class="">
                <el-form :model="form_params" :rules="rules" ref="edit_form" style="overflow-y: auto;max-height: 600px;">
                    <div class="dialog_path_title eldialogFormTag">基本信息</div>
                    <div class="eldialogFormBox clearfix">
                        <el-form-item label="公司名称：" prop="name">
                            <el-input class="edit_input" v-model="form_params.name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="公司地址：" prop="address">
                            <el-input class="edit_input" v-model="form_params.address" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="所属人：" prop="salesman_id">
                            <el-select class="edit_input" v-model="form_params.salesman_id" @visible-change="getSelectList('user')" :disabled="isSeeEdit">
                                <el-option v-for="sale in selectMap.user" :key="sale.id" :value="sale.id" :label="sale.name" ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="电话/传真：" prop="fax">
                            <el-input class="edit_input" v-model="form_params.fax" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="工厂规模：" prop="factory_size">
                            <el-input class="edit_input" v-model="form_params.factory_size" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="厂房信息：" prop="factory_size">
                            <el-input class="edit_input" v-model="form_params.factory_info" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="采购木种：" prop="wood_category">
                            <el-input class="edit_input" v-model="form_params.wood_category" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="其他信息：" prop="other_info">
                            <el-input class="edit_input" v-model="form_params.other_info" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogFormBox clearfix">
                        <el-form-item label="所在省份：" prop="province_id">
                            <el-select class="edit_input" v-model="form_params.province_id" @change="changePro($event,2)" :disabled="isSeeEdit">
                                <el-option v-for="pro in proList" :key="pro.id" :value="pro.id" :label="pro.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所在城市：" prop="city_id">
                            <el-select class="edit_input" v-model="form_params.city_id" :disabled="isSeeEdit">
                                <el-option v-for="city in cityList" :key="city.id" :value="city.id" :label="city.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户属性：" prop="customer_attribute_id">
                            <el-select class="edit_input" v-model="form_params.customer_attribute_id" @visible-change="getSelectList('customerAttribute')" :disabled="isSeeEdit">
                                <el-option v-for="attribute in selectMap.customerAttribute" :key="attribute.id" :value="attribute.id" :label="attribute.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户来源：" prop="customer_source_id">
                            <el-select class="edit_input" v-model="form_params.customer_source_id" @visible-change="getSelectList('customerSource')" :disabled="isSeeEdit">
                                <el-option v-for="source in selectMap.customerSource" :key="source.id" :value="source.id" :label="source.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="主营项目：" prop="main_business">
                            <el-input class="edit_input" v-model="form_params.main_business" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="信用指数：" prop="star">
                            <el-select class="edit_input" v-model="form_params.star" :disabled="isSeeEdit">
                                <el-option :value="1" :label="'一星'"></el-option>
                                <el-option :value="2" :label="'二星'"></el-option>
                                <el-option :value="3" :label="'三星'"></el-option>
                                <el-option :value="4" :label="'四星'"></el-option>
                                <el-option :value="5" :label="'五星'"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户文件：" v-if="form_params.files">
                            <span style="float: left;font-size: 12px;color: #b21111;" @click="openFile">资料查看</span><img  @click="openFile" class="file" src="/icon/file.png">
                        </el-form-item>
                        <el-form-item v-else>
                        </el-form-item>
                        <div class="mark">
                            <el-form-item label="备注：" prop="remark">
                                <!-- <el-input class="edit_input" v-model="form_params.remark" placeholder=""></el-input> -->
                                <div class="content_box">
                                    <span class="content">{{form_params.remark}}</span>
                                    <span class="edit cursorPointer" :disabled="isSeeEdit" @click="markEdits"></span>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="dialog_path_title eldialogFormTag">联系方式</div>
                    <template v-for="(item,index) in form_params.contacts">                
                        <div :class="['link_item', index == 0 ? '':'add_item']" :key="index">
                            <div class="eldialogFormBox clearfix">
                                <el-form-item label="联系人：" :prop="`contacts[${index}].contact`" :rules="{ required: true, message: '必填项', trigger: 'change' }">
                                    <el-input v-model="item.contact" class="edit_input" :disabled="isSeeEdit"></el-input>
                                </el-form-item>
                                <el-form-item label="联系电话：" :prop="`contacts[${index}].phone`" :rules="{ required: true, message: '必填项', trigger: 'change' }">
                                    <el-input v-model="item.phone" class="edit_input" :disabled="isSeeEdit"></el-input>
                                </el-form-item>            
                            </div>
                            <div class="eldialogFormBox clearfix">
                                <el-form-item label="微信：">
                                    <el-input v-model="item.wechat" class="edit_input" :disabled="isSeeEdit"></el-input>
                                </el-form-item>
                                <el-form-item label="电子邮箱：">
                                    <el-input v-model="item.email" class="edit_input" :disabled="isSeeEdit"></el-input>
                                </el-form-item>
                            </div>
                            <!-- <div :class="['item_icon','cursorPointer',index == 0 ? 'add_icon':'del_icon']"  @click="addOrDelete(index)"></div> -->
                        </div>
                    </template>    
                    <div class="dialog_path_title eldialogFormTag">开票资料</div>
                    <div class="eldialogFormBox eldialogFormTag clearfix">
                        <el-form-item label="名称：" prop="invoice_name" style="margin-top: 21px;">
                            <el-input class="edit_input" v-model="form_params.invoice_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="开户行：" prop="invoice_bank_name" style="margin-top: 21px;">
                            <el-input class="edit_input" v-model="form_params.invoice_bank_name" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogFormBox eldialogFormTag clearfix">
                        <el-form-item label="税号：" prop="invoice_no">
                            <el-input class="edit_input" v-model="form_params.invoice_no" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="账号：" prop="invoice_bank_no">
                            <el-input class="edit_input" v-model="form_params.invoice_bank_no" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogFormBox eldialogFormTag clearfix">
                        <el-form-item label="地址：" prop="invoice_addr">
                            <el-input class="edit_input" v-model="form_params.invoice_addr" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="invoice_phone">
                            <el-input class="edit_input" v-model="form_params.invoice_phone" placeholder="" :disabled="isSeeEdit"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <!-- <el-button  class="publicBtn dialogBtn" @click="addCustomer">确定</el-button> -->
                <el-button class="dialogBtn funcPublicBtn" @click="customerDetail=!customerDetail">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 分配 START -->
        <el-dialog v-dialog-drag title="分配客户：" :visible.sync="selectDialogVisible" class="eldialog eldialogOneLabel" :model="false" width="400px" custom-class="full_dialog">
            <el-row class="cont_top">
                <el-form :model="ruleForm" ref="ruleForm" size="mini">
                    <el-form-item label="销售员：">
                        <el-select v-model="ruleForm.salesman_id" placeholder="销售员" @visible-change="getSelectList('user')">
                            <el-option v-for="sale in selectMap.user" :key="sale.id" :value="sale.id" :label="sale.name"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </el-row>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="distribution">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="selectDialogVisible=!selectDialogVisible">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 分配 End -->
        <!--execl START-->
        <el-dialog v-dialog-drag title="客户导入" :visible.sync="importDialogVisible" class="eldialog eldialogA" :modal="false" width='500px'>
			<div class="text-center"  style="margin-top:20px;">
				<el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".xls,.xlsx">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;">点击上传</em></div>
					<div class="el-upload__tip" slot="tip"  style="color: #888;margin-top:20px;">只能上传Excel文件</div>
				</el-upload>
				<div class="">
					<el-link type="primary" @click='downTemplete' style="color:#b21111;font-weight:bold; cursor:pointer;">下载模板</el-link>
				</div>
			</div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="importFile">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="importDialogVisible=!importDialogVisible">取消</el-button>
            </div>
		</el-dialog>
        <!--execl END-->
        <!-- 上传文件 -->
        <el-dialog v-dialog-drag title="上传文件" :visible.sync="importFiles" class="eldialog eldialogA" :modal="false" width='500px'>
			<div class="text-center"  style="margin-top:20px;">
				<el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".xls,.xlsx,.txt,image/jpeg,image/png">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;">点击上传</em></div>
				</el-upload>
			</div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="filesYes">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="importFiles=!importFiles">取消</el-button>
            </div>
		</el-dialog>
        <!-- 备注 -->
        <el-dialog title="备注" :visible.sync="markDialogVisible" class="eldialog mark_dialog" width="350px" :modal="false" :before-close="markhandleClose" v-dialogDrag>
            <div>
                <el-input type="textarea" :rows="5" placeholder="请输入内容" maxlength=100 v-model="form_params.remark"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="sm_confirm_btn" type="primary" size="small" @click="markDialogVisible=false">确认</el-button>
            </span>
        </el-dialog>
        <!-- 备注 -->
        <el-dialog title="备注" :visible.sync="markDialogVisibles" class="eldialog mark_dialog" width="350px" :modal="false" :before-close="markhandleCloses" v-dialogDrag>
            <div>
                <el-input type="textarea" :rows="5" placeholder="请输入内容" maxlength=100 v-model="form_params.remark" :disabled="isSeeEdit"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="sm_confirm_btn" type="primary" size="small" @click="markDialogVisibles=false">确认</el-button>
            </span>
        </el-dialog>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="customer.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<style scoped lang="scss">
    .dialog_path_title{text-align: center;font-size:14px; font-weight:bold; line-height:25px; color: #606266;padding-bottom:20px;background-color: #fff;}
    .search_box{padding-right:230px;}
    .execlInsert .excel_btn{display: inline;}
        .link_item{
            // padding-right: 50px;
            // margin:0 37px;      
            // margin-top:20px;
            position:relative;
        .item_icon{      
            position:absolute;
            right: 0px;
            top:26px;
            display: block;
            width: 25px;
            height: 25px;
        }
        .add_icon{           
            background: url(/icon/frame_plus.png) center center no-repeat;
            background-size: 16px 16px;
        }
        .del_icon{
            background: url(/icon/frame_minus.png) center center no-repeat;
            background-size: 16px 16px;
        }
        }
        .add_item{
            border-top: 1px dashed #aaa;
            margin-top: 0px;
            padding-top: 10px;
        }
        .file{
            width: 20px;
            float: left;
            margin-left: 5px;
            margin-top: 1px;
        }
        .mark{
            .content_box{
                width: 140px; 
                border-bottom: 1px solid #DCDFE6;
                display:flex;
                padding-left: 10px;
                .content{
                    flex: 1;
                    display: inline-block;
                    width: 120px;
                    height: 24px;
                    text-align:left;
                    overflow:hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 12px;
                }
                .edit{
                    display:inline-block;
                    width:20px;
                    background: url(/icon/operation_edit.png) 100% 65% no-repeat;
                    background-size: 16px 16px;
                }         
            }
        }
</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                //导入 start
                importDialogVisible:false,
                upload_data : {},
				oss : {
                    host : "",
                },
				file_url : '',
                //导入 end
                selectList:[],
                ruleForm:{
                    ids:[],
                    salesman_id:""
                },
                params:{
                    keyword: "",
                    salesman_id: [],
                    main_business: "",
                    customer_source_id:[],
                    customer_attribute_id:[],
                    province_id:"",
                    city_id:"",
                    lock_status:"",
                    per_page: 50,
                    page:1
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2新增，3修改
                list : [],
                proList:[],
                cityList:[],
                cityListS:[],
                selectMap:{
                    user:[],
                    customerSource:[],
                    customerAttribute:[],
                    disabledUser:[]
                },
                selectDialogVisible:false,
                // dialog START
                dialogVisible : false,
                filterDialogVisible:false,
                filter:"",
                fields:"",
                form_params : {
                    id:"",
                    name : "",
                    salesman_id : localStorage.dw_erp_user_id ? parseInt(localStorage.dw_erp_user_id) : "",
                    // linkman : "",
                    // phone : "",
                    address : "",
                    province_id : "",
                    city_id : "",
                    // email : "",
                    main_business : "",
                    remark : "",
                    // wechat: "",
                    fax: "",
                    customer_attribute_id: "",
                    customer_source_id: "",
                    star:"",
                    invoice_name:"",
                    invoice_no:"",
                    invoice_bank_name:"",
                    invoice_bank_no:"",
                    invoice_addr:"",
                    invoice_phone:"",
                    factory_size:"",
                    factory_info:"",
                    wood_category:"",
                    other_info:"",
                    contacts:[
                         {contact: '', phone:'', wechat: '', email: ''}
                    ],
                },
                rules: {
                    name : [ { required: true, message: '请输入公司名称', trigger: 'blur' } ],
                    salesman_id : [ { required: true, message: '请选择归属人', trigger: 'blur' } ],
                    // linkman : [ { required: true, message: '请输入联系人', trigger: 'blur' } ],
                    // phone : [ {required: true,  message: '请输入联系电话', trigger: 'blur' } ]
                },
                tableCol:[	
                    {colName:"状态",colKey:"status_text",isEdit:true,isDelete:true,isStatus:true},
                    {colName:"录入日期",colKey:"create_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"公司名称",colKey:"name",colWidth:190,isSetWidth:true,isCanClick:true},
                    {colName:"锁定状态",colKey:"lock_status_text",colWidth:80,isSetWidth:true,isShow:true,isCanClickLocks:true},
                    {colName:"所属人",colKey:"salesman_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"联系人",colKey:"linkman",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"联系电话",colKey:"phone",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"电话/传真",colKey:"fax",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"电子邮件",colKey:"email",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"主营业务",colKey:"main_business",colWidth:190,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"微信",colKey:"wechat",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"客户属性",colKey:"customer_attribute_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"客户来源",colKey:"customer_source_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"工厂规模",colKey:"factory_size",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"厂房信息",colKey:"factory_info",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购木种",colKey:"wood_category",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"其他信息",colKey:"other_info",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"客户关联文件",colKey:"files",colWidth:100,isSetWidth:true,isCanClick:true,isColor:true,isHideShowClickImg:true,},
                    // {colName:"客户星级",colKey:"star",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"是否店铺用户",colKey:"",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"省份",colKey:"province_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"城市",colKey:"city_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"公司地址",colKey:"address",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                // dialog END
                // uploadExecl START
                show_upload : false,
                // uploadExecl END
                importFiles:false,
                markDialogVisible:false,
                markDialogVisibles:false,
                markCopy: '',//备注复制
                customerDetail:false,
                isSeeEdit:false,    
                isShowMore:false,
            }
        },
        created(){
            this.getSelectList("disabledUser")
            this.getSelectList("user")
            this.getSelectList("customerSource")
            this.getSelectList("customerAttribute")
            this.getArea().then(resolve=>{
                this.proList=resolve.data.data;
            })
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
        },
        methods:{
            batchDel(){
                if(this.selectList.length<1){
                    this.tip("请选择客户","warning")
                }else{
                    this.$confirm('是否删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let arr = new Array();
                        this.selectList.forEach(item=>{
                            arr.push(item.id)
                        })
                        this.postFunc("/erp/customer.delete",{ids:arr},()=>{
                            this.tip("删除成功","success")
                            this.getList();
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
            },
            batchLock(){
                if(this.selectList.length<1){
                    this.tip("请选择客户","warning")
                }else{
                    this.$confirm('是否上锁?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let arr = new Array();
                        this.selectList.forEach(item=>{
                            arr.push(item.id)
                        })
                        this.postFunc("/erp/customer.lock",{ids:arr,status:1},()=>{
                            this.tip("锁定成功","success")
                            this.getList();
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
            },
            batchUnlocking(){
                if(this.selectList.length<1){
                    this.tip("请选择客户","warning")
                }else{
                    this.$confirm('是否解锁?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let arr = new Array();
                        this.selectList.forEach(item=>{
                            arr.push(item.id)
                        })
                        this.postFunc("/erp/customer.lock",{ids:arr,status:0},()=>{
                            this.tip("解锁成功","success")
                            this.getList();
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
            },
            uploadFile(){
                 if(this.selectList.length<1){
                    this.tip("请选择客户","warning")
                } else if(this.selectList.length>1){
                    this.tip("选择数量不能大于" + 1 + "条","warning")
                }else{
                    this.importFiles = true
                }
            },
            openFile(){
                 window.open(this.form_params.files)
            },
            //备注编辑
            markEdit(){
                this.markDialogVisible = true
                this.markCopy = this.form_params.remark
            },
            //备注编辑
            markEdits(){
                this.markDialogVisibles = true
                this.markCopy = this.form_params.remark
            },
            //弹窗关闭回调
            markhandleClose(){
                this.markDialogVisible  =false 
                this.form_params.remark = this.markCopy
            },
            //弹窗关闭回调
            markhandleCloses(){
                this.markDialogVisibles=false 
                this.form_params.remark = this.markCopy
            },
            exportExcelBill(){
                this.$exportExecl("/erp/customer.export","客户",this.params)
            },
            filterConfirm(){
                this.getList()
            },
            getSelectList(target){
                let obj = new Object();
                if(target=="disabledUser"){
                    obj.show_disabled = 1;
                }
                this.$getSelectList(target,obj).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            distributionDia(){
                if(this.selectList.length<=0){
                    this.tip("请选择客户","warning")
                }else{
                    this.selectDialogVisible=!this.selectDialogVisible
                }
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.getList()
            },
            //新增表单 多个联系人删除修改
            addOrDelete(index){
                let newForm = JSON.parse(JSON.stringify(this.form_params))
                if(index == 0){
                    newForm.contacts.push( {contact: '',phone:'',wechat: '',email: ''})
                }else{
                    newForm.contacts.splice(index, 1)
                }
                this.form_params = newForm
            },
            selectChange(row){
                this.selectList=row;
            },
            distribution(){
                this.ruleForm.ids=[];
                this.selectList.forEach(item=>{
                    this.ruleForm.ids.push(item.id)
                })
                this.postFuncLoading("/erp/customer.alloc",this.ruleForm,()=>{
                    this.selectDialogVisible=false;
                    this.tip("分配成功","success")
                    this.getList();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
               
            },
            del(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFunc("/erp/customer.delete",{id:id},()=>{
                        this.tip("删除成功","success")
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            statusClick(data){      
                data.status = Number(data.status) === 1 ? 0 : 1;
                this.postFunc("erp/customer.status",data,()=>{
                    this.getList()
                })
            },
            openAddCustmoer(){
                this.updataType=2
                this.form_params.contacts = [{contact: '',phone:'',wechat: '',email: ''}]
                this.dialogVisible = true;
                this.form_params.salesman_id = localStorage.dw_erp_user_id ? parseInt(localStorage.dw_erp_user_id) : ""
            },
            edit(id){
                this.dialogVisible=true;
                this.updataType=3;
                this.form_params.contacts = [{contact: '',phone:'',wechat: '',email: ''}]
                this.postFunc('erp/customer.info',{id:id},res=>{
                    let resData = res.data.data
                    resData.province_id = resData.province_id === 0 ? '' : resData.province_id
                    resData.city_id = resData.city_id === 0 ? '' : resData.city_id
                    resData.star = resData.star === 0 ? '' : resData.star
                    resData.customer_source_id = resData.customer_source_id === 0 ? '' : resData.customer_source_id
                    resData.customer_attribute_id = resData.customer_attribute_id === 0 ? '' : resData.customer_attribute_id
                    resData.salesman_id = resData.salesman_id              
                    this.getArea(res.data.data.province_id).then(resolve=>{
                        this.cityList = resolve.data.data;
                        this.form_params = res.data.data
                    }) 
                    // this.form_params = this.clearZero(this.form_params)
                })
            },
            rowClick(obj){
                if(obj.name==='name'){
                    this.postFunc('erp/customer.info',{id:obj.id},resD=>{
                        this.isSeeEdit = true
                        this.customerDetail = true
                        let resData = resD.data.data
                        resData.province_id = resData.province_id === 0 ? '' : resData.province_id
                        resData.city_id = resData.city_id === 0 ? '' : resData.city_id
                        resData.star = resData.star === 0 ? '' : resData.star
                        resData.customer_source_id = resData.customer_source_id === 0 ? '' : resData.customer_source_id
                        resData.customer_attribute_id = resData.customer_attribute_id === 0 ? '' : resData.customer_attribute_id
                        resData.salesman_id = resData.salesman_id              
                        this.form_params = resD.data.data
                    })

                }
                if(obj.name==='files'){
                    window.open(obj.row.newFiles)
                }
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.$postColumnList("/erp/customer.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.data;
                    this.list.forEach((item,ind)=>{
                        item.newFiles = item.files;
                        if(item.files){
                            item.files = "查看详情";
                        }
                        if(item.create_time){
                            this.list[ind].create_time = this.formatTime(this.list[ind].create_time+"000")
                            if(localStorage.dw_erp_power_code){
                                if(localStorage.dw_erp_power_code.indexOf(",customer-edit,")!=-1){
                                    if(item.lock_status==1){
                                        item.isEdit=false;
                                    }else{
                                        item.isEdit=true;
                                    }
                                }
                                if(localStorage.dw_erp_power_code.indexOf(",customer-del,")!=-1){
                                    if(item.lock_status==1){
                                        item.isDelete=false;
                                    }else{
                                        item.isDelete=true;
                                    }
                                }
                                if(item.lock_status==1){
                                    item.isDialogViewlocks=true
                                }
                            }
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            changePro(val,type){
                if(val == ''){
                    if(type == 1){
                        this.params.city_id = ""
                        this.cityListS = []     
                    }else{
                        this.form_params.city_id = ""
                        this.cityList = []
                    }           
                    return
                }
                this.getArea(val).then(resolve=>{
                    if(type==1){
                        this.cityListS=resolve.data.data;
                        this.params.city_id="";
                    }else{
                        this.cityList=resolve.data.data;
                        this.form_params.city_id="";
                    }
                })
            },
            addCustomer(){
                this.$refs["edit_form"].validate((valid) => {
					if (valid) {
                        if(this.updataType==2){
                            this.postFuncLoading("/erp/customer.create",this.form_params,()=>{
                                this.tip("添加成功","success")
                                this.getList();
                                this.form_params = this.resetJson(this.form_params)
                                this.dialogVisible=false;
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }else{
                            this.postFuncLoading("/erp/customer.update",this.form_params,()=>{
                                this.tip("修改成功","success")
                                this.getList();
                                this.dialogVisible=false;
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }
					} else {
						return false;
					}
				});
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },

            //导入 start
            handleSuccess(res) {
                this.file_url = res.data.base_url;
				this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            importFile(){
                this.analysis('/erp/import.qc.customer',this.file_url,"","","",response=>{
                    if (response.data.code == 0) {
                        this.tip("上传成功","success")
                        this.getList()
                        this.importDialogVisible=false;
                    }else{
                        this.tip(response.data.message,"warning")
                    }
                })
            },
            filesYes(){
                let arr = []
                this.selectList.forEach(item=>{
                    arr.push(item.id)
                })
                this.postFunc('erp/customer.file.upload',{id:Number(arr),files:this.file_url},()=>{
                    this.tip("上传成功","success")
                    this.getList()
                    this.importFiles=false;
        })
            },
            downTemplete(){
                this.exportFile("qc_customer","","","",response=>{
					const content = response.data;
                    const blob = new Blob([content], {type: response.headers['content-type']});
					const fileName = '客户导入模板'+this.getDownloadTempleteTime(new Date())+'.xlsx';
					if ('download' in document.createElement('a')) { // 非IE下载
						const elink = document.createElement('a');
						elink.download = fileName;
						elink.style.display = 'none';
						elink.href = URL.createObjectURL(blob);
						document.body.appendChild(elink);
						elink.click();
						URL.revokeObjectURL(elink.href); // 释放URL 对象
						document.body.removeChild(elink);
					} else { // IE10+下载
						navigator.msSaveBlob(blob, fileName);
					}
                })
                // this.exportFile("qc_customer").then( (response) => {
				// })
            },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                })
            }
            //导入 end
        },
         watch:{
            dialogVisible:function(val){
                if(!val){
                    this.form_params = this.resetJson(this.form_params)
                }
            },
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
        }
    }
</script>
